import { SquareUserIcon } from "lucide-react";
import { MdOutlineSpaceDashboard } from "react-icons/md";

export function getMenuList(pathname) {
  return [
    {
      groupLabel: "",
      menus: [
        // {
        //   href: "/",
        //   label: "dashboard",
        //   active: pathname === "/",
        //   icon: MdOutlineSpaceDashboard,
        //   submenus: [],
        // },
        {
          href: "/users",
          label: "users",
          active: pathname === "/users" || pathname === "/",
          icon: SquareUserIcon,
          submenus: [],
        },
        {
          href: "/jobs",
          label: "jobs",
          active: pathname === "/jobs",
          icon: MdOutlineSpaceDashboard,
          submenus: [],
        },
        // {
        //   href: "/maplimit",
        //   label: "maplimit",
        //   active: pathname === "/maplimit",
        //   icon: MdOutlineSpaceDashboard,
        //   submenus: [],
        // }
        {
          href: "/jobreport",
          label: "jobreport",
          active: pathname === "/jobreport",
          icon: MdOutlineSpaceDashboard,
          submenus: [],
        },
      ],
    },
  ];
}
